import { render } from "./Logo.vue?vue&type=template&id=eeb99062&scoped=true"
const script = {}

import "./Logo.vue?vue&type=style&index=0&id=eeb99062&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eeb99062"]])

export default __exports__